// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

window.Stimulus = Application.start()
const context = require.context("controllers", true, /_controller\.js$/)
Stimulus.load(definitionsFromContext(context))

// Component controllers: load with a prefix to avoid conflicts with controllers in this directory
// app/components/ui/example/example_controller.js turns into component-example
const componentControllersContext = require.context("../../components/ui", true, /_controller\.js$/)
const componentDefs = definitionsFromContext(componentControllersContext)
const defsWithShortId = componentDefs.map((def) => ({
  ...def,
  identifier: "component-" + def.identifier.split("--").pop()
}))
Stimulus.load(defsWithShortId)